module.exports = __webpack_public_path__ + "static/media/Smit3.487cf6d3.jpg";